import React from 'react';
import { CardFooter, CardBody, ListGroup, ListGroupItem, Button, Card } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useParams } from 'react-router-dom';
import { orderBy } from 'lodash';
import { CardHeader, PseudoStates, useFetch } from '@cordata/buffet';

import { CardItemLimit } from '~/utils';

import ListGroupItemNotes from './ListGroupItem';

const CardNotes = () => {
  const params = useParams();
  const [status, data] = useFetch(`/patients/${params.patient_id}/notes`);

  return (
    <Card body={false} footer={false}>
      <CardHeader
        className="text-light"
        color="primary"
        action={
          <Button
            outline
            tag={Link}
            color="light"
            to={`/patients/${params.patient_id}/notes/add`}
            size="sm"
          >
            <FontAwesomeIcon icon="plus" />
          </Button>
        }
      >
        Notes
      </CardHeader>

      <CardBody className="p-0">
        {status === 'success' ? (
          <ListGroup flush>
            {orderBy(
              data.filter(r => !r.attributes.isArchived),
              r => r.attributes.createdDate,
            ).reverse().slice(0, CardItemLimit).map(d => (
              <ListGroupItemNotes
                key={d.id}
                data={d}
                params={params}
              />
            ))}

            {!data.length && (
              <ListGroupItem>
                No Notes
              </ListGroupItem>
            )}
          </ListGroup>
        ) : (
          <PseudoStates isLoading={status === 'loading'} error={status === 'error'} />
        )}
      </CardBody>

      <CardFooter
        tag={Link}
        to={`/patients/${params.patient_id}/notes`}
        className="text-center"
      >
        Show More ...
      </CardFooter>
    </Card>
  );
};

export default CardNotes;
